export default __webpack_public_path__ + "static/media/green-dropdown.84bf7eb0.svg";